module.exports = __webpack_public_path__ + "images/emoji/books.bc86e7d55e71d56688f8.png";